import React from 'react';
import { Helmet } from 'react-helmet';
import { configService } from '../services';
import { t } from 'i18next';

export const Error404: React.FC = () => {

    return <>
        <Helmet title={`${configService.current().applicationTitle} - Page not found`} />
        <main className="d-flex flex-column align-items-center justify-content-center text-center" >
            {/* <div className='banner'></div> */}
            <h1>{t("page_404_heading")}</h1>
            <p>{t("page_404_message")} </p>
            <a className='btn' href={t("page_404_button_url")}>{t("page_404_button_text")}</a>

        </main>
    </>
}